import React, { useState, useEffect } from "react";
import { NavigationContainer } from "@react-navigation/native";
import * as SplashScreen from "expo-splash-screen";

import AppNavigator from "./navigation/AppNavigator";
import UserContext from "./context/userContext";
import UsersContext from "./context/usersContext";
import VehiclesContext from "./context/vehiclesContext";
import ProductsContext from "./context/productsContext";
import PopUpContext from "./context/popUpContext";
import cache from "./utility/cache";

SplashScreen.preventAutoHideAsync().catch(() => {
    console.warn();
});

export default function App() {
    const [user, setUser] = useState({});
    const [users, setUsers] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [message, setMessage] = useState();
    const [products, setProducts] = useState([]);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        restoreUser();
    }, []);

    const restoreUser = async () => {
        const user = await cache.getUser();

        if (user) {
            setUser(user);
        }

        await SplashScreen.hideAsync();
        setIsReady(true);
    };

    //if (!isReady) return <AppLoading startAsync={restoreUser} onFinish={() => setIsReady(true)} onError={console.warn} />;
    if (!isReady) return null;

    return (
        <UserContext.Provider value={{ user, setUser }}>
            <UsersContext.Provider value={{ users, setUsers }}>
                <VehiclesContext.Provider value={{ vehicles, setVehicles }}>
                    <ProductsContext.Provider value={{ products, setProducts }}>
                        <PopUpContext.Provider value={{ message, setMessage }}>
                            <NavigationContainer>{<AppNavigator />}</NavigationContainer>
                        </PopUpContext.Provider>
                    </ProductsContext.Provider>
                </VehiclesContext.Provider>
            </UsersContext.Provider>
        </UserContext.Provider>
    );
}
